import React from "react";

export interface BadgeProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "success" | "error" | "warning" | "info" | "gray";
  size?: "sm" | "md" | "lg";
  dot?: boolean;
  icon?: React.ReactNode;
  className?: string;
}

export function Badge({
  children,
  variant = "gray",
  size = "md",
  dot = false,
  icon,
  className = "",
}: BadgeProps) {
  const variantStyles = {
    primary: "bg-primary-100 text-primary-800 border-primary-200",
    secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
    success: "bg-accent-100 text-accent-800 border-accent-200",
    error: "bg-rose-100 text-rose-800 border-rose-200",
    warning: "bg-amber-100 text-amber-800 border-amber-200",
    info: "bg-sky-100 text-sky-800 border-sky-200",
    gray: "bg-slate-100 text-slate-800 border-slate-200",
  };

  const sizeStyles = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-1 text-sm",
    lg: "px-3 py-1.5 text-base",
  };

  const dotColors = {
    primary: "bg-primary-600",
    secondary: "bg-secondary-600",
    success: "bg-accent-600",
    error: "bg-rose-600",
    warning: "bg-amber-600",
    info: "bg-sky-600",
    gray: "bg-slate-600",
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-semibold
        border rounded-full
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        ${className}
      `
        .trim()
        .replace(/\s+/g, " ")}
    >
      {dot && <span className={`w-2 h-2 rounded-full ${dotColors[variant]}`} />}
      {icon && <span className="inline-flex">{icon}</span>}
      {children}
    </span>
  );
}
